import { isAuthenticated } from '@/modules/user/helpers/guards';
import Home from './views/Home.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: isAuthenticated,
  },
];

export default routes;
